<template>
  <router-view />
</template>

<style lang="scss" scoped>
@import "@/styles/utils";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: rgb(20, 20, 21);
  color: #2c3e50;
}

nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    @extend %hide;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
